import { MODELPROPERTIES, FIELDARRAY, FIELD, IFieldSchema, STATICMETHOD, METHOD } from "../../../";
import { GetMongooseFieldSchema } from "./GetMongooseFieldSchema";

function cloneObject(item: any) {
    if (item == null || typeof item != "object") return item;
    var clone = {};
    for (var key in item) {
        if (item.hasOwnProperty(key)) {
            clone[key] = cloneObject(item[key]);
        }
    }
    return clone;
}

/**
 * Helper function that will build out each piece of the model-decorator API and convert it to a mongoose model object
 * 
 * @param constructor: any
 *   The constructor we need to build the mongoose object out of
 * @return: any
 *   Will return a mongoose model object ready to be processed by mongoose
 */
export function GetInternalMongooseMetaData(constructor: any): any {
    let obj: any = new constructor();
    let data: any = { schema: { }, static: { }, method: { } };
    let fields: string[] = Reflect.getMetadata(MODELPROPERTIES, obj);
    for (let i = 0; i < fields.length; ++i) {
        let fieldArray = Reflect.getMetadata(FIELDARRAY, obj, fields[i]);
        if (fieldArray !== undefined) {
            let field: IFieldSchema = cloneObject(Reflect.getMetadata(FIELD, obj, fields[i]));
            field.type = fieldArray;
            if (field !== undefined) {
                data.schema[fields[i]] = [GetMongooseFieldSchema(field)];
            }
            continue;
        }

        let field: IFieldSchema = cloneObject(Reflect.getMetadata(FIELD, obj, fields[i]));
        if (field !== undefined) {
            data.schema[fields[i]] = GetMongooseFieldSchema(field);
            continue;
        }

        let staticMethod = Reflect.getMetadata(STATICMETHOD, constructor, fields[i]);
        if (staticMethod !== undefined) {
            data.static[fields[i]] = staticMethod;
            continue;
        }

        staticMethod = Reflect.getMetadata(STATICMETHOD, obj, fields[i]);
        if (staticMethod !== undefined) {
            data.static[fields[i]] = staticMethod;
            continue;
        }

        let method = Reflect.getMetadata(METHOD, obj, fields[i]);
        if (method !== undefined) {
            data.method[fields[i]] = method;
            continue;
        }
    }
    return data;
}